// extracted by mini-css-extract-plugin
export var sliderRange = "_n4-2";
export var sliderRoot = "_n4-0";
export var sliderThumb = "_n4-3";
export var sliderTrack = "_n4-1";